import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';

type Props = BaseButtonProps;

export const ArrowFloorButton = ({ children, ...props }: Props) => {
    return (
        <BaseButton {...props} className={styles['arrow-floor-button']}>
            {children}
        </BaseButton>
    );
};
